module.exports = __webpack_public_path__ + "static/ogp-home-674365a0668f612abc9b2fb0fa1088f2.png";